// src/lakehouse/ui/admin/src/features/datasets/lib/operatorsForType.ts
import type { FilterOperator } from '../types/query.types';

export const ALL_OPERATORS: FilterOperator[] = [
  '=', '!=', '<', '<=', '>', '>=', 'in', 'not in',
  'contains', 'icontains', 'like', 'ilike',
  'is null', 'is not null', 'between',
];

const UNIVERSAL: FilterOperator[] = ['=', '!=', 'in', 'not in', 'is null', 'is not null'];
const COMPARISON: FilterOperator[] = ['<', '<=', '>', '>=', 'between'];
// #877: `contains`/`icontains` do substring search (backend wraps the value as
// %value%); `like`/`ilike` stay for power users supplying their own wildcards.
const STRING_OPS: FilterOperator[] = ['contains', 'icontains', 'like', 'ilike'];

export function classify(type: string): 'numeric' | 'temporal' | 'string' | 'boolean' | 'other' {
  const t = (type || '').toUpperCase();
  if (/^(BOOL)/.test(t)) return 'boolean';
  // Temporal MUST run before numeric: INTERVAL contains "INT" which the
  // numeric regex would otherwise match first.
  if (/(DATE|TIME|TIMESTAMP|INTERVAL)/.test(t)) return 'temporal';
  if (/(INT|DECIMAL|DOUBLE|FLOAT|REAL|NUMERIC|HUGEINT)/.test(t)) return 'numeric';
  if (/(CHAR|TEXT|STRING|VARCHAR|UUID)/.test(t)) return 'string';
  return 'other';
}

export function operatorsForType(type: string): FilterOperator[] {
  switch (classify(type)) {
    case 'numeric':
    case 'temporal':
      return [...UNIVERSAL, ...COMPARISON];
    case 'string':
      return [...UNIVERSAL, ...STRING_OPS];
    case 'boolean':
    case 'other':
    default:
      return [...UNIVERSAL];
  }
}
